export const MAX_FILE_SIZE_KB = 300000;
export const MAX_FILE_SIZE_MSG = "Total Files size should be less than 300mb";
